import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
 
@Component({
  selector: 'app-cookie-consent',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cookie-consent.component.html',
  styleUrls: ['./cookie-consent.component.scss'],
})
export class CookieConsentComponent implements OnInit {
  private readonly CONSENT_KEY = 'cookie_consent_accepted';
  showBanner = false;
 
  ngOnInit(): void {
    if (localStorage.getItem(this.CONSENT_KEY) !== 'true') {
      this.showBanner = true;
    }
  }
 
  acceptCookies(): void {
    localStorage.setItem(this.CONSENT_KEY, 'true');
    this.showBanner = false;
  }
}